/** 幫任何 Promise 加上超時保護，避免請求卡住時畫面永遠轉圈圈 */
export function withTimeout<T>(
  promise: PromiseLike<T>,
  ms: number,
  label = "請求",
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    let settled = false;
    const timer = setTimeout(() => {
      if (settled) return;
      settled = true;
      reject(new Error(`${label}超時（${Math.round(ms / 1000)} 秒），請確認網路連線後重試`));
    }, ms);

    Promise.resolve(promise).then(
      (res) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(res);
      },
      (err) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        reject(err);
      },
    );
  });
}